<template>
  <div id="landing-ex">
    <template v-if="isMobile">
      <LadLandingCoverCustom
        cache-prefix="landing-cover-custom"
        :cache-key="cacheKey"
      />
      <LadAffix
        class="affix"
        relative-element-selector=".main-container"
        :offset="{ top: -650, bottom: 0 }"
        :enabled="!isLandingAvailabilityCustomVisible"
      >
        <LadLandingBookNowCustom
          v-show="availabilityInitialized"
          :abtesting="abtesting"
          @go-to-dates="goToDates"
        />
      </LadAffix>

      <LadLandingBeginEndDaysCustom />
      <LadLandingWhatsIncludedCustom
        cache-prefix="landing-whats-included-custom"
        :cache-key="cacheKey"
      />
      <LadLandingItineraryCustom
        cache-prefix="landing-itinerary-custom"
        :cache-key="cacheKey"
      />

      <LadLandingStartYourAdventureCustom
        cache-prefix="landing-start-your-adventure-custom"
        :cache-key="cacheKey"
      />

      <LadLandingReviewsCustom v-if="exReviews.count" />

      <LadLandingAvailabilityCustom
        v-if="
          exExperience.isLad &&
          abtesting === 'gnrl3' &&
          availabilityInitialized &&
          hasAvailability
        "
        cache-prefix="landing-whats-availability-custom"
        :cache-key="cacheKey"
        @is-visible="isVisibleHandle"
      />
    </template>
    <template v-else>
      <LadLandingCoverCustom
        cache-prefix="landing-cover-custom"
        :cache-key="cacheKey"
      />
      <div class="landing-sections--wrapper">
        <div>
          <LadLandingBeginEndDaysCustom />
          <LadLandingWhatsIncludedCustom
            cache-prefix="landing-whats-included-custom"
            :cache-key="cacheKey"
          />
          <LadLandingItineraryCustom
            cache-prefix="landing-itinerary-custom"
            :cache-key="cacheKey"
          />
        </div>
        <div>
          <LadLandingBookNowCustom
            v-if="availabilityInitialized"
            @go-to-form="goToForm"
          />

          <LadLandingStartYourAdventureCustom
            cache-prefix="landing-start-your-adventure-custom"
            :cache-key="cacheKey"
          />
        </div>
      </div>
    </template>

    <LadLandingReviewsCustom v-if="!isMobile && exReviews.count" />

    <div
      v-if="!isMobile"
      id="lad-landing--form"
      class="experience-wrapper--container-contact-us"
    >
      <LazyLoading
        :key="`contact`"
        :loaded="lazy.contact"
        :loading="lazy.contact === false"
        @loaded="(e) => (lazy.contact = e)"
      >
        <LadLandingFormCustom />

        <template slot="css-skeleton" />
      </LazyLoading>
    </div>
    <!-- <div v-else-if="hasItinerary" class="landing-wrapper bg-white">
      <el-container class="landing-wrapper__itinerary bg-white">
        <el-header class="landing-wrapper--header" align="center">
          <h2>{{
            $t(`${base}.itinerary_of_experience`, {
              name: exExperience.name,
            })
          }}</h2>
        </el-header>

        <el-main>
          <Swiper ref="swiperLocations" :options="swiperOption">
            <SwiperSlide
              v-for="(itinerary, i) in exItinerary"
              :key="i"
              class="swiper-slide"
            >
              <LadCardItinerary
                :shadow="'false'"
                :item="itinerary"
                :base="base"
              />
            </SwiperSlide>

            <div slot="pagination" class="swiper-pagination"></div>

            <div slot="button-prev" class="swiper-button-prev"></div>
            <div slot="button-next" class="swiper-button-next"></div>
          </Swiper>
        </el-main>
      </el-container>
    </div>
    <el-container v-if="abtesting === 'gnrl2'" class="container-video">
      <el-main align="center">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/7PHey-Lj8TI"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </el-main> </el-container
    >
    <div id="landing-wrapper--main-top" v-loading="loading">
      <LadAffix
        class="affix"
        relative-element-selector="#landing-wrapper--main-top"
        :offset="{ top: 0, bottom: 60 }"
      >
        <div class="wrapper-lazy-loading">
          <LadLandingPriceNavbar />
        </div>
      </LadAffix>

      <div v-if="!isMobile && !isViatorPlatform" class="download-wrapper">
        <LadItineraryDownload
          cache-prefix="landing-download-itinerary"
          :cache-key="cacheKey"
        />
      </div>

      <LadBreadcrumb v-if="!isMobile" />

      <div v-if="showFacebookWidget" class="landing-wrapper">
        <el-container class="lad-facebook-post">
          <el-header class="landing-wrapper--header" align="center">
            <h2>{{ $t(`${base}.fb_testimonials`) }}</h2>
          </el-header>

          <el-main>
            <div class="lad-facebook-post--wrapper">
              <LadFacebookPostWidget
                v-if="showFacebookWidget"
                :post-id="postId"
              />
              <LadFacebookTestimonialsSlider v-else />
            </div>
          </el-main>
        </el-container>
      </div>

      <div v-if="!isMobile" class="landing-wrapper">
        <el-container class="lad-facebook-post">
          <el-header class="landing-wrapper--header" align="center">
            <h2>{{ $t(`${base}.fb_testimonials`) }}</h2>
          </el-header>

          <el-main>
            <div class="lad-facebook-post--wrapper">
              <LadFacebookTestimonialsSlider />
            </div>
          </el-main>
        </el-container>
      </div>

      <LazyHydrate v-if="!isMobile" :when-visible="{ rootMargin: '100px' }">
        <div :class="['landing-wrapper', showFacebookWidget ? 'bg-white' : '']">
          <el-container>
            <el-header class="landing-wrapper--header" align="center">
              <h2>{{ $t('landing.features.includes') }}</h2>
            </el-header>

            <el-main>
              <LadWhatsIncluded
                cache-prefix="landing-whats-included"
                :cache-key="cacheKey"
              />
            </el-main>
          </el-container>
        </div>
      </LazyHydrate>

      <div v-if="!isMobile" class="landing-media-wrapper">
        <LadLandingMedia cache-prefix="landing-medias" :cache-key="cacheKey" />
      </div>

      <template v-if="!isMobile && changeOrderTemplate">
        <template v-if="exReviews.count">
          <LazyLoading
            :key="`reviews`"
            :loaded="lazy.reviews"
            :loading="lazy.reviews === false"
            @loaded="(e) => (lazy.reviews = e)"
          >
            <LadReviewsExperience
              v-if="lazy.reviews"
              id="experience-wrapper--main-reviews"
              :top="60"
              class="wrapper--main-reviews"
            />

            <template slot="css-skeleton">
              <LadReviewsExperienceLoader />
            </template>
          </LazyLoading>
        </template>
      </template>

      <div
        v-if="!isMobile"
        id="lad-landing--form"
        class="experience-wrapper--container-contact-us"
      >
        <LazyLoading
          :key="`contact`"
          :loaded="lazy.contact"
          :loading="lazy.contact === false"
          @loaded="(e) => (lazy.contact = e)"
        >
          <LadLandingFormCustom />

          <template slot="css-skeleton" />
        </LazyLoading>
      </div>

      <div v-if="!isMobile" class="wrapper-customer-benefits">
        <LadLocalFlexSummary />
      </div>

      <template v-if="!changeOrderTemplate">
        <template v-if="!isMobile && exReviews.count">
          <LazyLoading
            :key="`reviews`"
            :loaded="lazy.reviews"
            :loading="lazy.reviews === false"
            @loaded="(e) => (lazy.reviews = e)"
          >
            <LadReviewsExperience
              v-if="lazy.reviews"
              id="experience-wrapper--main-reviews"
              :top="60"
              class="wrapper--main-reviews"
            />

            <template slot="css-skeleton">
              <LadReviewsExperienceLoader />
            </template>
          </LazyLoading>
        </template>
      </template>
    </div>

    <LadConfidence
      v-if="!isMobile"
      cache-prefix="lad-confidence"
      :cache-key="cacheKey"
    />

     <LadGotoMoreInformation :only-mobile="true" :delay="1000" /> -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { hydrateWhenVisible } from 'vue-lazy-hydration'
import AnalyticsExperienceMixin from '@/utils/mixin/analytics-experience'
import ExperienceMetaMixin from '@/utils/mixin/product-meta'

export default {
  name: 'LadLanding',
  components: {
    // LadCardItinerary: () =>
    //   import(
    //     /* webpackChunkName: "lad-card-itinerary" */ '@/components/card/components/itineraryz'
    //   ),
    // LadBreadcrumb: () =>
    //   import(
    //     /* webpackChunkName: "lad-breadcrumb" */ '@/components/breadcrumb/index'
    //   ),
    // LadWhatsIncluded: () =>
    //   import(
    //     /* webpackChunkName: "lad-landing-whats-included" */ '@/components/pages/landing/partials/whats-included'
    //   ),
    // LadLandingMedia: () =>
    //   import(
    //     /* webpackChunkName: "lad-landing-media" */ '@/components/pages/landing/partials/media'
    //   ),
    // LadItineraryDownload: () =>
    //   import(
    //     /* webpackChunkName: "lad-itinerary-download" */ '@/components/itinerary/download/index'
    //   ),
    // LadReviewsExperience: () =>
    //   import(
    //     /* webpackChunkName: "lad-reviews" */ '@/components/lad-reviews/experience'
    //   ),
    // LadReviewsExperienceLoader: () =>
    //   import(
    //     /* webpackChunkName: "lad-reviews-loader" */ '@/components/css-skeleton/reviews-loader'
    //   ),
    // LadFacebookTestimonialsSlider: () =>
    //   import(
    //     /* webpackChunkName: "lad-face-testimonials" */ '@/components/facebook/testimonials'
    //   ),
    // LadFacebookPostWidget: () =>
    //   import(
    //     /* webpackChunkName: "lad-face-post" */ '@/components/facebook/post'
    //   ),
    // LadFacebookWidget: () =>
    //   import(
    //     /* webpackChunkName: "lad-face-widget" */ '@/components/facebook/widget'
    //   ),
    // LadLandingPriceNavbar: () =>
    //   import(
    //     /* webpackChunkName: "lad-landing-price" */ '@/components/navbars/landing-price'
    //   ),
    // LadZohoFormLead: () =>
    //   import(
    //     /* webpackChunkName: "lad-zoho-form--lead" */ '@/components/zoho-form/lead'
    //   ),
    // LadLocalFlexSummary: hydrateWhenVisible(() =>
    //   import(
    //     /* webpackChunkName: "lad-local-flex-summary" */ '@/components/local-flex-summary'
    //   )
    // ),
    // LadConfidence: () =>
    //   import(
    //     /* webpackChunkName: "lad-confidence" */ '@/components/confidence'
    //   ),

    // LadGotoMoreInformation: () =>
    //   import(
    //     /* webpackChunkName: "lad-goto-more-information" */ '@/components/pages/experience/partials/goto-more-information'
    //   ),
    LadLandingCoverCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-cover-custom" */ '@/components/pages/landing/partials/custom/cover'
      ),
    LadLandingBeginEndDaysCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-begin-end-days-custom" */ '@/components/pages/landing/partials/custom/begin-end-days'
      ),
    LadLandingWhatsIncludedCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-whats-included-custom" */ '@/components/pages/landing/partials/custom/whats-included'
      ),
    LadLandingItineraryCustom: hydrateWhenVisible(() =>
      import(
        /* webpackChunkName: "lad-landing-itinerary-custom" */ '@/components/pages/landing/partials/custom/itinerary'
      )
    ),
    LadLandingStartYourAdventureCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-start-your-adventure-custom" */ '@/components/pages/landing/partials/custom/start-your-adventure'
      ),
    LadLandingReviewsCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-reviews-custom" */ '@/components/pages/landing/partials/custom/reviews'
      ),
    LadLandingBookNowCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-book-now-custom" */ '@/components/pages/landing/partials/custom/book-now'
      ),
    LadLandingAvailabilityCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-availability-custom" */ '@/components/pages/landing/partials/custom/availability/index'
      ),
    LadLandingFormCustom: () =>
      import(
        /* webpackChunkName: "lad-landing-reviews-custom" */ '@/components/pages/landing/partials/custom/contact-form'
      ),
  },
  mixins: [AnalyticsExperienceMixin, ExperienceMetaMixin],
  async asyncData({ app, store, route, params, redirect }) {
    let loading = !!process.server

    const response = await store.dispatch('experience/getData', {
      permalink: params.permalink,
    })

    if (response === 'success') {
      await store.dispatch(
        'availability/hasAvailability',
        store.state.experience.experience.availability.dates
      )

      await store.dispatch(
        'availability/hasRecommendedAvailability',
        store.state.experience.experience.availability.recommended
      )

      const items = store.state.experience.breadcrumbs

      if (Object.keys(items).length > 0) {
        const breadcrumb = []
        const keys = ['continent', 'country', 'city']

        keys.forEach((key) => {
          if (items[key]) {
            const to = {
              name: key === 'country' ? 'search-country' : 'search-type',
              params: {
                type: app.i18n.t(`router.search_type.type.${key}`),
                value: items[key].slug,
                tab:
                  key === 'country'
                    ? null
                    : app.i18n.t('router.search_type.tab.tours'),
                travelTo: app.i18n.t('router.search_type.travel_to_'),
              },
            }

            breadcrumb.push({ to, text: items[key].name })
          }
        })

        breadcrumb.push({
          to: null,
          text: store.state.experience.experience.name,
        })

        await store.dispatch('app/setBreadcrumb', breadcrumb)
      }
    } else {
      const {
        status,
        data: { data },
      } = response

      if (status === 301) {
        redirect(status, route.fullPath.replace(params.permalink, data))
      } else {
        redirect('/404')
      }
    }

    loading = false

    return { loading }
  },
  data() {
    return {
      base: 'landing.index',
      loading: false,
      submitted: false,
      lazy: {
        reviews: false,
        contact: false,
        features: false,
      },
      swiperOption: {
        autoplay: { delay: 5000, disableOnInteraction: false },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
          },
          // when window width is >= 800px
          800: {
            slidesPerView: 1,
          },
        },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange: () => {
            const swiper = this.$refs.swiperLocations.$swiper

            if (!!swiper && swiper.activeIndex && !isNaN(swiper.activeIndex)) {
              this.current = swiper.activeIndex % this.exItinerary.length
            }
          },
        },
      },
      gallery: [],
      availabilityInitialized: false,
      isLandingAvailabilityCustomVisible: false,
    }
  },
  computed: {
    ...mapState('experience', {
      promotions: 'promotions',
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        isLad: state.experience.is_lad,
        name: state.experience.name,
        keywords: state.experience.keywords,
        headline: state.experience.headline,
        permalink: state.experience.permalink.default,
        facebook_group_id: state.experience.facebook_group_id,
        starting_point: state.experience.starting_point,
        country: state.experience.country,
        starting_point_country: state.experience.starting_point_country,
        ending_point_country: state.experience.ending_point_country,
      }),
      exPlatform: (state) => state.platform,
      isViatorPlatform: (state) => state.platform.name === 'Viator',
      exItinerary: (state) => state.itinerary,
      exDescription: (state) => state.experience.brief_description,
      isPackage: (state) => state.experience.type === 'package',
      totalAmount: (state) => state.sales_plan.total_amount,
      layawayAmount: (state) => state.sales_plan.layaway_amount,
      exCover: 'cover',
      exGallery: 'gallery',
      exReviews: 'reviews',
    }),
    ...mapState('settings', ['currency']),
    ...mapGetters('settings', ['language']),
    ...mapGetters('device', ['isMobile']),
    ...mapState('availability', {
      hasAvailability: (state) => state.exist,
    }),
    changeOrderTemplate() {
      const list = []

      return list.includes(this.exExperience.uuid)
    },
    showFacebookWidget() {
      const enabled = []

      return enabled.includes(this.exExperience.uuid)
    },
    postId() {
      return process.env.FACEBOOK_POST_ID_IN_LANDING
    },
    hasItinerary() {
      return this.exItinerary.length > 0
    },
    itinerarySectionTitle() {
      // Itinerario de
      return this.hasItinerary
        ? this.$t(`${this.base}.know_the_itinerary`)
        : this.$t(`${this.base}.know_the_experience`)
    },
    cacheKey() {
      return `landing-${this.exExperience.uuid}--${this.language}-${
        this.currency
      }--${this.isMobile ? 'm' : 'd'}--${
        this.$route.params.test ? this.$route.params.test : 'base'
      }`
    },
    abtesting() {
      return this.$route.params.test
    },
    isProductSoccer() {
      return process.env.PRODUCTS_SOCCER.includes(this.exExperience.uuid)
    },
  },
  watch: {
    'exExperience.uuid': {
      immediate: true,
      async handler(uuid, oldValue) {
        if (process.server) return false

        if (uuid) {
          await this.$store.dispatch(
            'app/updateWrapper',
            `wrapper--landing-${uuid}`
          )

          this.sendAnalytics()

          if (typeof oldValue === 'undefined') {
            this.loadAvailability()
          }
        }
      },
    },
  },
  created() {
    this.$nuxt.$on('set-preload', (response) => {
      this.gallery.push(response)
    })
  },
  async beforeDestroy() {
    this.$nuxt.$off('set-preload')

    /** no quitar condicion, no carga cuando hace busqueda de una experiencia en top navbar */
    if (
      ![
        'checkout-layaway',
        'landing-permalink-test',
        'h-permalink',
        'f-permalink',
        'product-permalink',
        'product-permalink-ppcv1',
      ].includes(this.$route.name)
    ) {
      await this.$store.dispatch('availability/setDefault')
      await this.$store.dispatch('experience/setDefault')
    }
  },
  mounted() {
    if (this.$route.query.video === 'localflex') {
      this.LadNextTick(() => {
        this.$scrollTo('.wrapper-search-bottom', 400, { offset: -120 })
      }, 'LadLanding')
    }
  },
  methods: {
    handleSubmitted() {
      this.submitted = true
    },
    async loadAvailability() {
      await this.$store.dispatch('availability/getData', {
        experience: this.$route.params.permalink,
        withRestriction: true,
        withCodes: this.exPlatform.name === 'LocalAdventures',
      })
      this.availabilityInitialized = true
    },
    goToDates() {
      this.$scrollTo('.lad-landing-availability__custom')
    },
    goToForm() {
      this.$scrollTo('#lad-landing--form')
    },
    isVisibleHandle(visible) {
      this.isLandingAvailabilityCustomVisible = visible
    },
  },
  validate({ params }) {
    /** validando parametros opcionales */
    return typeof params.test === 'undefined'
      ? true
      : /gnrl1|gnrl2|gnrl3|exp1/.test(params.test)
  },
  head() {
    const experienceMeta = ExperienceMetaMixin.head.call(this)

    const preloads = []

    this.gallery.forEach(({ sources, medias }) => {
      sources.forEach((source, i) => {
        preloads.push({
          rel: 'preload',
          as: 'image',
          fetchpriority: 'high',
          imagesrcset: source,
          media: medias[i].media,
        })
      })
    })

    return {
      ...experienceMeta,
      link: preloads,
      meta: [].concat(experienceMeta.meta, [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ]),
    }
  },
}
</script>

<style lang="scss">
#landing-ex {
  color: #4c4f56;

  @media screen and (min-width: 768px) {
    .landing-sections--wrapper {
      background-color: #fff;
      padding: 20px 40px 0 40px;
      display: grid;
      grid-template-columns: auto 400px;
    }
  }

  @keyframes swipe {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: 0 0;
    }
  }

  .landing-wrapper__itinerary {
    .swiper-pagination {
      position: absolute;
      top: 10px;
      display: flex;
      align-items: stretch;

      .swiper-pagination-bullet {
        flex-grow: 1;
        height: 4px;
        display: inline-block;
        border-radius: unset;
        background: rgba(0, 0, 0, 0.5);
        opacity: 1;

        &-active {
          background-image: -webkit-linear-gradient(
            left,
            rgba(255, 255, 255, 1) 0%,
            rgba(255, 255, 255, 1) 50%,
            rgba(88, 89, 104, 1) 50.001%,
            rgba(88, 89, 104, 1) 100%
          );
          background-repeat: no-repeat;
          background-size: 200%;
          background-color: white;
          background-position: 100% 50%;
          animation-timing-function: linear;
          animation-delay: 0s;
          animation-name: swipe;
          animation-duration: 5s; // autopaly 시간과 맞춰주기
          animation-iteration-count: 1;
          animation-direction: alternate;
          animation-fill-mode: forwards;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      display: flex;
      margin: 0;
      padding: 0;
      width: 50px;
      height: 100%;
      border-radius: unset;
      top: 0;
      opacity: 0;

      @media (min-width: 768px) {
        height: 30px;
        width: 30px;
        opacity: 0.5;
        color: black;
        background: white;
        top: 50%;

        &::after {
          font-size: 18px;
        }

        &:hover {
          opacity: 1;
        }
      }
    }

    .swiper-button-prev {
      left: 0;

      @media (min-width: 768px) {
        left: 10px;
      }
    }

    .swiper-button-next {
      right: 0;

      @media (min-width: 768px) {
        right: 10px;
      }
    }
  }

  .swiper-container {
    .swiper-slide {
      position: relative;
      .number-itinerary {
        height: 3rem;
        position: absolute;
        top: 10%;
        left: 50%;
        z-index: 30;
        transform: translate(-1%, -50%);
        background-color: white;
        border-radius: 50%;
        width: 3rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #2f8742;
      }
    }
  }

  .affix {
    width: 100%;
    z-index: 3;
  }

  .landing-wrapper {
    &--header {
      padding: 0;
      height: auto !important;

      h2 {
        font-size: 30px;
      }

      span {
        text-transform: uppercase;
        font-size: 16px;
      }
    }

    .el-main {
      padding: 0;
    }
  }

  .lad-zoho {
    background-color: white;
  }

  .landing-itinerary-wrapper {
    background-color: white;
    border-bottom: 1px solid #ddd;

    @media screen and (max-width: 700px) {
      .wrapper-days-itinerary {
        padding: 0 20px;
      }
    }
  }

  .lad-facebook-post {
    .el-main {
      padding: 0;
    }

    &--wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
  }

  .download-wrapper {
    border-bottom: 1px solid #ddd;
    background-color: white;

    .lad-itinerary-download {
      max-width: 1170px;
      margin: 0 auto;
      border: 0;
      h2 {
        margin-top: 0;
      }
    }
  }

  .itinerary-section-description {
    padding: 0 20px 30px;
  }

  .landing-media-wrapper {
    border: 1px solid #ddd;
    background-color: white;

    .lad-landing-media {
      max-width: 1170px;
      margin: 0 auto;
      border: 0;
    }
  }

  .bg-white {
    background-color: #fff;
  }

  .wrapper-search-bottom {
    flex-direction: column;
  }

  .wrapper-customer-benefits {
    min-height: 330px;
    padding-top: 30px;
    background: rgb(48, 134, 66);
    background: -moz-linear-gradient(
      0deg,
      rgba(48, 134, 66, 1) 0%,
      rgba(37, 160, 72, 1) 65%,
      rgba(67, 190, 93, 1) 100%
    );
    background: -webkit-linear-gradient(
      0deg,
      rgba(48, 134, 66, 1) 0%,
      rgba(37, 160, 72, 1) 65%,
      rgba(67, 190, 93, 1) 100%
    );
    background: linear-gradient(
      0deg,
      rgba(48, 134, 66, 1) 0%,
      rgba(37, 160, 72, 1) 65%,
      rgba(67, 190, 93, 1) 100%
    );
    filter: progid:dximagetransform.microsoft.gradient(startColorstr="#308642",endColorstr="#43be5d",GradientType=1);
  }

  #landing-wrapper--main-top {
    .landing-wrapper--reviews-navbar {
      position: absolute;

      @media only screen and (min-width: 1029px) {
        position: inherit;
      }
    }
  }

  @media only screen and (max-width: 1026px) {
    #landing-wrapper--main-top > div:nth-child(2) {
      padding-top: 0;
    }
  }

  .container-video {
    iframe {
      @media only screen and (max-width: 600px) {
        width: 100%;
        height: 300px;
      }

      @media only screen and (max-width: 420px) {
        height: 230px;
      }
    }
  }
}
</style>
